import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LanguageIcon from '@mui/icons-material/Language';
import BaseMenuList from '@mui/material/MenuList';
import AppBar from 'src/components/BaseAppBar';
import Footer from 'src/components/Footer';
import D21Logo from 'src/components/icons/D21Logo';
import Langs from 'src/components/Langs';
import Menu from 'src/components/Menu';
import { DataTestIds } from 'src/config/dataTestIds';
import useTranslationSwitch from 'src/hooks/useTranslationSwitch';
import * as S from './ExternalTemplate.styles';
const ExternalTemplate = ({
  children,
  className,
  bar = {
    show: true,
    onlyLogo: false
  },
  href = '/login'
}) => {
  const {
    currentLanguage,
    setActiveLang
  } = useTranslationSwitch({});
  return /*#__PURE__*/React.createElement(S.Wrapper, {
    className: className
  }, bar.show && /*#__PURE__*/React.createElement(AppBar, {
    middleContent: /*#__PURE__*/React.createElement(S.Link, {
      "data-testid": DataTestIds.HeaderLogo,
      href: href,
      passHref: true
    }, /*#__PURE__*/React.createElement(D21Logo, null)),
    rightContent: !bar.onlyLogo && /*#__PURE__*/React.createElement(Menu, {
      justifyContent: "right",
      trigger: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LanguageIcon, null), /*#__PURE__*/React.createElement(ArrowDropDownIcon, null))
    }, /*#__PURE__*/React.createElement(BaseMenuList, null, /*#__PURE__*/React.createElement(Langs, {
      currentLanguage: currentLanguage,
      changeLanguage: setActiveLang
    })))
  }), /*#__PURE__*/React.createElement(S.Content, null, children), /*#__PURE__*/React.createElement(Footer, null));
};
export default ExternalTemplate;